import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState, useEffect, useContext } from "react";
import { MsalContext } from "../../../Contexts/MsalContext";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';

interface IClientFiltersDialogProps {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    currentClient: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ClientFiltersDialog({ open, setOpen, currentClient, changeFilter }: IClientFiltersDialogProps) {
    const { msalFetch } = useContext(MsalContext)
    const [client, setClient] = useState(currentClient);
    const [clientList, setClientList] = useState<string[]>([])

    useEffect(() => {
        msalFetch(`api/User/GetClientList`)
            .then(response => {
                if (response.ok) {
                    return response.json()
                }
                return null;
            })
            .then(data => {
                if (data != null) {
                    setClientList(data);
                }
            })
    }, [])

    const confirm = () => {
        changeFilter('client', client);
        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Client Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid size={12} >
                            <Select
                                value={client}
                                onChange={(e) => setClient(e.target.value as string)}
                                endAdornment={client &&
                                    <IconButton onClick={() => setClient('')} sx={{ marginRight: 2 }}>
                                        <ClearIcon />
                                    </IconButton>}
                                fullWidth>
                                {
                                    clientList.map(item =>
                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}